import { render, staticRenderFns } from "./bloodFat.vue?vue&type=template&id=4db4e3a0&scoped=true"
import script from "./bloodFat.vue?vue&type=script&lang=js"
export * from "./bloodFat.vue?vue&type=script&lang=js"
import style0 from "./bloodFat.vue?vue&type=style&index=0&id=4db4e3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4e3a0",
  null
  
)

export default component.exports